import { z } from 'zod'

export const TravelerSchema = z.object({
  age: z.number().optional(),
  ageGroup: z.any().optional(),
  dateOfBirth: z.string().optional(),
  roomGroup: z.number().optional(),
})
